import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import Select, {
  components,
  IndicatorComponentType,
  NamedProps,
} from 'react-select';
import { InputLabel } from 'src/web/components/InputLabel/component';
import {
  OL_COLOUR_BLACK_55,
  OL_COLOUR_BLACK_90,
  OL_COLOUR_HIGHLIGHT,
} from 'src/web/components/Style/colours';
import {
  FOCUS_BOX_SHADOW,
  FOCUS_OUTLINE,
  FOCUS_OUTLINE_OFFSET,
} from 'src/web/components/Style/mixins';
import { StyledDropdownIcon } from './styles';

export type OptionType = { label: string; value: string };

const DropdownIndicator: IndicatorComponentType<OptionType, true> = (props) => {
  const { selectProps } = props;
  return (
    <components.DropdownIndicator {...props}>
      {selectProps.menuIsOpen ? (
        <StyledDropdownIcon icon={faCaretUp} />
      ) : (
        <StyledDropdownIcon icon={faCaretDown} />
      )}
    </components.DropdownIndicator>
  );
};

interface MultiSelectProps extends NamedProps<OptionType, true> {
  label?: string;
}

/**
 * @param props is extensible from react-select Select component
 * @returns MultiSelect component which has the base design from SingleSelect
 */
export const MultiSelect: React.FC<MultiSelectProps> = (props) => {
  const { label } = props;
  return (
    <>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        isMulti
        styles={{
          option: (base, state) => ({
            ...base,
            background:
              state.isSelected || state.isFocused
                ? OL_COLOUR_HIGHLIGHT
                : 'transparent',
            color: OL_COLOUR_BLACK_90,
            '&:focus': {
              background: OL_COLOUR_HIGHLIGHT,
            },
            '&:active': {
              background: OL_COLOUR_HIGHLIGHT,
            },
          }),
          menu: (base) => ({
            ...base,
            marginTop: 0,
            borderRadius: '2px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
          }),
          menuList: (base) => ({
            ...base,
            padding: 0,
            fontSize: 14,
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          control: (base, state) => ({
            ...base,
            fontSize: 14,
            border: `1px solid ${OL_COLOUR_BLACK_55}`,
            borderRadius: '2px',
            outlineOffset: state.menuIsOpen ? FOCUS_OUTLINE_OFFSET : 'none',
            outline: state.menuIsOpen ? FOCUS_OUTLINE : 'none',
            boxShadow: state.menuIsOpen ? FOCUS_BOX_SHADOW : 'none',
            '&:hover': {
              border: `1px solid ${OL_COLOUR_BLACK_55}`,
            },
          }),
        }}
        components={{ DropdownIndicator }}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isClearable={false}
        {...props}
      />
    </>
  );
};
